import { GET_ORDER_GIFT_WRAP_INFO } from '../actionTypes/OrderActionTypes';

export const getOrderGiftWrapInfo = (payload) => ({
    type: GET_ORDER_GIFT_WRAP_INFO,
    payload,
});

export default getOrderGiftWrapInfo;
